import { Reveal, SectionLabel } from "./Reveal";

const LEVELS = [
  { code: "L0", name: "Oral", body: "Knowledge lives in people's heads. Retrieval is by meeting. Turnover is amnesia.", tag: null },
  { code: "L1", name: "Recorded", body: "Written down and searchable — and decaying immediately, because updating it is nobody's job. Where most companies sit.", tag: "Most companies today" },
  { code: "L2", name: "Connected", body: "Sources unified. Anyone asks across all of them and gets a cited, permission-scoped answer. Latency collapses from days to seconds.", tag: null },
  { code: "L3", name: "Self-aware", body: "The organization notices its own contradictions without being asked. Drift surfaces internally before it surfaces at a client.", tag: "Qwiri in 90 days" },
  { code: "L4", name: "Compounding", body: "Ambiguity resolves itself. Judgment tunes to this company specifically. A new joiner starts with full context on day one.", tag: "Over 18 months" },
  { code: "L5", name: "Deciding", body: "The system models consequences, carries the record of past decisions and their outcomes, and recommends inside bounds you set.", tag: "What becomes possible" },
];

export const Ladder = () => (
  <section id="levels" data-testid="ladder-section" className="grid-lines-dark bg-black text-white">
    <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
      <SectionLabel index="05" title="The ladder" dark />
      <Reveal className="mt-10">
        <h2 className="max-w-4xl text-[28px] font-bold leading-tight tracking-tight md:text-[40px]">
          Six levels of organizational intelligence.{" "}
          <span className="text-white/40">Every company sits on one rung today.</span>
        </h2>
      </Reveal>

      <div className="mt-16 border border-white/20">
        {LEVELS.map((l, i) => (
          <Reveal key={l.code} delay={i * 0.05}>
            <div
              data-testid={`ladder-row-${l.code.toLowerCase()}`}
              className={`group grid grid-cols-[64px_1fr] items-baseline gap-4 border-b border-white/20 px-5 py-6 transition-colors duration-150 last:border-b-0 hover:bg-white hover:text-black md:grid-cols-[100px_180px_1fr_auto] md:px-8 md:py-7 ${
                l.code === "L3" ? "bg-white text-black hover:bg-black hover:text-white" : ""
              }`}
            >
              <span className="text-2xl font-extrabold tracking-tighter md:text-3xl">{l.code}</span>
              <span className="text-lg font-bold tracking-tight md:text-xl">{l.name}</span>
              <span className={`col-span-2 text-sm leading-relaxed md:col-span-1 md:text-base ${
                l.code === "L3" ? "text-black/65 group-hover:text-white/65" : "text-white/55 group-hover:text-black/65"
              }`}>
                {l.body}
              </span>
              {l.tag && (
                <span className={`col-span-2 w-fit px-2 py-1 text-[10px] font-bold uppercase tracking-[0.18em] md:col-span-1 ${
                  l.code === "L3" ? "bg-black text-white group-hover:bg-white group-hover:text-black" : "border border-white/40 text-white/70 group-hover:border-black group-hover:text-black"
                }`}>
                  {l.tag}
                </span>
              )}
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-14">
        <p className="max-w-3xl text-xl font-bold leading-snug tracking-tight md:text-2xl" data-testid="ladder-closing-line">
          The measure: a company running Qwiri for two years should be able to do things a company
          running it for two weeks cannot. <span className="text-white/40">If not, we built a search box.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
